import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-delete-dialog',
  templateUrl: './delete-dialog.component.html',
  styleUrls: ['./delete-dialog.component.scss'],
  standalone: false
})
export class DeleteDialogComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<DeleteDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DeleteDialogData) { }

  ngOnInit(): void {
  }

  onConfirm(): void {
    this.data.confirm();
    this.dialogRef.close(true);
  }

  onDismiss(): void {
    this.data.cancel();
    this.dialogRef.close(false);
  }
}

export interface DeleteDialogData {
  confirm: Function;
  cancel: Function;
}
